import React, { ReactNode } from 'react';
import SettingsContext, {SettingsContextType} from './context';

type SettingsProviderProps = {
    children: ReactNode;
};
const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
    // @ts-ignore
    const settings: SettingsContextType = {
        ...window.EMPRIVA_CONDOLEANCEREGISTER_SETTINGS || {},
    };

    // console.log(settings);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsProvider;
